export const polygonLayerDefinition = {
    geometryType: 'esriGeometryPolygon',
    objectIdField: 'uniqueId',
    extent: {
        xmin: 93.60870361299999,
        ymin: -54.20349121100003,
        xmax: 139.56890869100005,
        ymax: 24.052603350000027,
        spatialReference: {
            wkid: 7844,
            latestWkid: 7844
        }
    },
    fields: [
        {
            name: 'objectid',
            type: 'esriFieldTypeOID',
            alias: 'objectid',
            editable: false,
            nullable: true
        },
        {
            name: 'guid',
            type: 'esriFieldTypeString',
            alias: 'guid',
            editable: true,
            nullable: false,
            length: 50
        },
        {
            name: 'id',
            type: 'esriFieldTypeInteger',
            alias: 'id',
            editable: true,
            nullable: false
        },
        {
            name: 'type',
            type: 'esriFieldTypeInteger',
            alias: 'type',
            editable: true,
            nullable: true
        },
        {
            name: 'name',
            type: 'esriFieldTypeString',
            alias: 'name',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'statedarea',
            type: 'esriFieldTypeString',
            alias: 'statedarea',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'miscloseratio',
            type: 'esriFieldTypeDouble',
            alias: 'miscloseratio',
            editable: true,
            nullable: true
        },
        {
            name: 'misclosedistance',
            type: 'esriFieldTypeDouble',
            alias: 'misclosedistance',
            editable: true,
            nullable: true
        },
        {
            name: 'misclosebearing',
            type: 'esriFieldTypeDouble',
            alias: 'misclosebearing',
            editable: true,
            nullable: true
        },
        {
            name: 'construction',
            type: 'esriFieldTypeInteger',
            alias: 'construction',
            editable: true,
            nullable: true
        },
        {
            name: 'purpose',
            type: 'esriFieldTypeString',
            alias: 'purpose',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacypolytype',
            type: 'esriFieldTypeString',
            alias: 'legacypolytype',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'importlayername',
            type: 'esriFieldTypeString',
            alias: 'importlayername',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacypolyindent1',
            type: 'esriFieldTypeString',
            alias: 'legacypolyindent1',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacypolyindent2',
            type: 'esriFieldTypeString',
            alias: 'legacypolyindent2',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacyhouseno',
            type: 'esriFieldTypeString',
            alias: 'legacyhouseno',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'legacystreetname',
            type: 'esriFieldTypeString',
            alias: 'legacystreetname',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'spatiallinkid',
            type: 'esriFieldTypeString',
            alias: 'spatiallinkid',
            editable: true,
            nullable: true,
            length: 50
        },
        {
            name: 'miscloseangle',
            type: 'esriFieldTypeDouble',
            alias: 'miscloseangle',
            editable: true,
            nullable: true
        },
        {
            name: 'importfilename',
            type: 'esriFieldTypeString',
            alias: 'importfilename',
            editable: true,
            nullable: true,
            length: 255
        },
        {
            name: 'legacylocalpolygonno',
            type: 'esriFieldTypeInteger',
            alias: 'legacylocalpolygonno',
            editable: true,
            nullable: true
        },
        {
            name: 'legacyrecordid',
            type: 'esriFieldTypeInteger',
            alias: 'legacyrecordid',
            editable: true,
            nullable: true
        },
        {
            name: 'roadid',
            type: 'esriFieldTypeInteger',
            alias: 'roadid',
            editable: true,
            nullable: true
        },
        {
            name: 'lotid',
            type: 'esriFieldTypeInteger',
            alias: 'lotid',
            editable: true,
            nullable: true
        },
        {
            name: 'lineids',
            type: 'esriFieldTypeString',
            alias: 'lineids',
            length: 1073741822,
            editable: true,
            nullable: true
        },
        {
            name: 'interestids',
            type: 'esriFieldTypeString',
            alias: 'interestids',
            length: 10024,
            editable: true,
            nullable: true
        }
    ]
};
